import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { PageInfo } from 'src/app/core/models/page-info';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { deepCopy, getDataScopeByPermission, getRoleScopeColumnMappings, getForwarderByPermission, isNullOrEmpty, laaSFormatString, capitalizeFirstLetter } from 'src/app/core/utils/common-functions';
import { WarehousingAbnormalService } from '../../services/warehousing-abnormal.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { FacilityService } from 'src/app/core/services/facility.service';
import { WarehousingAbnormalType } from 'src/app/core/enums/warehousing-abnormal-type.enum';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { BookingService } from '../../services/booking.service';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { MergeKeyService } from '../../services/merge-key.service';
import { WarehousingSearchService } from '../../services/warehousing-search.service';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, combineLatest, map } from 'rxjs';
import { formatDate } from '@angular/common';
import { Console } from 'console';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { MenuService } from 'src/app/core/services/menu.service';
import { OrgBrandMappingService } from '../../services/org-brand-mapping.service';

@Component({
  selector: 'laas-warehousing-abnormal',
  templateUrl: './warehousing-abnormal.component.html',
  styleUrls: ['./warehousing-abnormal.component.scss']
})
export class WarehousingAbnormalComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.ViewWarehousingAbnormal;
  readonly viewWarehousingAbnormalTrackingForShippingDialog = PermissionConstants.ViewWarehousingAbnormalTrackingForShippingDialog;
  readonly viewWarehousingAbnormalHandlingForPcsrDialog = PermissionConstants.ViewWarehousingAbnormalHandlingForPcsrDialog;

  readonly preferenceKeyAboutHawbNoData: string;
  readonly preferenceKeyAboutWarehousingHeaderData: string;
  readonly preferenceKeyAboutWarehousingAbnormalHeaderData: string;
  readonly preferenceKeyAboutWarehousingAbnormalDetailData: string;
  readonly preferenceKeyAboutAdvisingHeaderData: string;
  readonly preferenceKeyAboutAdvisingDetailData: string;

  isSearchFormOpen: boolean = true;
  isHawbTableOpen: boolean = false;
  isAbnormalTableOpen: boolean = false;
  isAdTableOpen: boolean = false;

  isLoading: boolean = false;
  isAbnormalLoading: boolean = false;
  isAdLoading: boolean = false;
  searchForm: FormGroup;

  importFailParams: any;
  hawbColumns: DateTableColumn[];
  hawbResults: any[] = [];
  hawbChildColumns: DateTableColumn[];

  abnormalColumns: DateTableColumn[];
  abnormalResults: any[] = [];
  abnormalChildColumns: DateTableColumn[];
  abnormalChildResults: any[] =[];
  adColumns: DateTableColumn[];
  adResults: any[] = [];
  adChildColumns: DateTableColumn[];
  fcStartWhDt: FormControl = new FormControl();
  fcEndWhDt: FormControl = new FormControl();
  selectedRow: { hawbNo: string, warehousingDetail: { whNo: string }[] } = { hawbNo: '', warehousingDetail: [] };

  /* Options */
  brandOptions: { label: string, value: string }[] = [];
  internalBrandOptions: { label: string, value: string }[] = [];  // V1.0 新增：內部品牌選項
  billCorpOptions: { label: string, value: string }[] = [];
  abnormalTypeOptions: { label: string, value: WarehousingAbnormalType }[] = [];
  yesNoOptions: { label: string, value: boolean }[] = [];
  ynOptions: { label: string, value: string }[] = [];
  deliveryOptions: any[] = [];
  whDocStatusOptions: any[] = [];
  shipTermOptions: LaasOption[] = [];
  bookingForwarderOptions: any[] = [];
  countryOptions: any[] = [];
  docTypeOptions: any[] = [];
  importTypeOptions: any[] = [];
  whDetailStatusOptions: any[] = [];
  letterHeadOptions: any[] = [];
  pickupLocationOptions: any[] = [];
  shipMethodOptions: any[] = [];
  priorityOptions: any[] = [];
  allCityOptions: any[] = [];
  allAreaOptions: any[] = [];
  vendorOptions: any[] = [];
  isActivatedOptions: any[] = [];
  deliverySubTypeOptions: any[] = [];
  isGenerateFeeOptions: any[] = [];
  isFeeCalculationOptions: any[] = [];
  urgentFlagOptions: any[] = [];
  facilityOptions: FacilityOptions[] = [];
  currentLang: string = this.laasSetting.language;

  /* Menus */
  itemMenus: MenuItem[] = [];

  /* Table setting */
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  sortOrder: SortOrder = {
    property: "whNo",
    direction: -1
  };
  abnormalPageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  abnormalSortOrder: SortOrder = {
    property: "whNo",
    direction: -1
  };
  adPageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  adSortOrder: SortOrder = {
    property: "adNo",
    direction: -1
  };

  /* 表格元素 */
  @ViewChild("hawbTable") hawbTable!: DataTableComponent;
  @ViewChild("abnormalTable") abnormalTable!: DataTableComponent;
  @ViewChild("adTable") adTable!: DataTableComponent;
  /* 日期元素 */
  @ViewChild('whDt') whDt!: CalendarComponent;
  @ViewChild('notifyDt') notifyDt!: CalendarComponent;
  @ViewChild('handleDt') handleDt!: CalendarComponent;

  /* Warehousing Abnormal History */
  isShowWarehousingAbnormalHistoryModal: boolean;
  warehousingAbnormalHistoryParams: any;

  /* Warehousing Abnormal Tracking For Shipping */
  isShowWarehousingAbnormalTrackingForShippingModal: boolean;
  warehousingAbnormalTrackingForShippingParams: any;

  /* Warehousing Abnormal Handling For Pcsr */
  isShowWarehousingAbnormalHandlingForPcsrModal: boolean;
  warehousingAbnormalHandlingForPcsrParams: any;

  isRwd: boolean = false;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private facilityService: FacilityService,
    private dropdownOptionsService: DropdownOptionsService,
    private warehousingAbnormalService: WarehousingAbnormalService,
    private route: ActivatedRoute,
    private bookingService: BookingService,
    private dOService: DeliveryOrderService,
    private commonDataService: CommonDataService,
    private warehousingSearchService: WarehousingSearchService,
    private mergeKeyService: MergeKeyService,
    private menuDataService: MenuService,
    private orgBrandMappingService: OrgBrandMappingService
  ) {
    super(injector);

    // //rbac to maintain this page
    // var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    // if (!canInPage) {
    //   //go unAuthorize
    //   this.routeStateService.navigateTo('/Error/unAuthorize');
    // }

    this.preferenceKeyAboutHawbNoData = UserPreferenceConstants.HawbNoDataOfWarehousingAbnormal;
    this.preferenceKeyAboutWarehousingHeaderData = UserPreferenceConstants.WarehousingHeaderDataOfWarehousingAbnormal;
    this.preferenceKeyAboutWarehousingAbnormalHeaderData = UserPreferenceConstants.WarehousingAbnormalHeaderData;
    this.preferenceKeyAboutWarehousingAbnormalDetailData= UserPreferenceConstants.WarehousingAbnormalDetailData;
    this.preferenceKeyAboutAdvisingHeaderData = UserPreferenceConstants.AdvisingHeaderDataOfWarehousingAbnormal;
    this.preferenceKeyAboutAdvisingDetailData = UserPreferenceConstants.AdvisingDetailDataOfWarehousingAbnormal;

    this.searchForm = this.fb.group({
      facility:null,
      whNo: null,
      hawbNo: null,
      startWhDt: new FormControl(),
      endWhDt: new FormControl(),
      brand: null,
      internalBrand: null,
      orgId: null,
      startNotifyDt: new FormControl(),
      endNotifyDt: new FormControl(),
      startHandleDt: new FormControl(),
      endHandleDt: new FormControl(),
      abnormalType: null,
      isNotified: null,
      isHandled: null,
    });

    this.hawbColumns = [
      { field: 'hawbNo', header: 'WarehousingAbnormal.Form.HawbNo', sort: true },
    ];
    this.hawbChildColumns = [
      { field: 'function', header: 'DOQuery.Form.Column.Features', sort: false },
      { field: 'isPrint', header: 'ReceiptForm.MainTable.IsPrinted', sort: true },
      { field: 'facility', header: 'ReceiptForm.MainTable.Facility', sort: true },
      { field: 'whNo', header: 'ReceiptForm.MainTable.ReceiptFormNum', sort: true },
      { field: 'originWhNo', header: 'ReceiptForm.MainTable.OriginalReceiptForm', sort: true },
      { field: 'orgId', header: 'ReceiptForm.MainTable.Company', sort: true },
      { field: 'billCorp', header: 'ReceiptForm.MainTable.ChargeBackCompany', sort: true },
      { field: 'deliveryType', header: 'ReceiptForm.MainTable.DocumentType', sort: true },
      { field: 'importDeclarationNo', header: 'ReceiptForm.MainTable.ImportDeclarationNum', sort: true },
      { field: 'urgentFlag', header: 'ReceiptForm.MainTable.IsUrgent', sort: true },
      { field: 'isGenerateFee', header: 'ReceiptForm.MainTable.GenerateExpenses', sort: true },
      { field: 'importAmount', header: 'ReceiptForm.MainTable.CustomsDeclarationAnt', sort: true },
      { field: 'whStatus', header: 'ReceiptForm.MainTable.ReceiptFormStatus', sort: true },
      { field: 'shipTerm', header: 'ReceiptForm.MainTable.TradeTerm', sort: true },
      { field: 'shipper', header: 'ReceiptForm.MainTable.Forwarder', sort: true },
      { field: 'vendorCustomerName', header: 'ReceiptForm.MainTable.Supplier', sort: true },
      { field: 'whDt', header: 'ReceiptForm.MainTable.ReceivingTime', dataType: 'date', sort: true },
      { field: 'expectedDt', header: 'ReceiptForm.MainTable.EstimateArrivalDay', dataType: 'date', sort: true },
      { field: 'hawbNo', header: 'ReceiptForm.MainTable.HAWB', sort: true },
      { field: 'fromCountry', header: 'ReceiptForm.MainTable.OriginCountry', sort: true },
      { field: 'fromCity', header: 'ReceiptForm.MainTable.OriginCity', sort: true },
      { field: 'fromArea', header: 'ReceiptForm.MainTable.OriginArea', sort: true },
      { field: 'palletCnt', header: 'ReceiptForm.MainTable.NumberPallets', sort: true },
      { field: 'totalCartonCnt', header: 'ReceiptForm.MainTable.TotalCartonCnt', sort: true },
      { field: 'totalChargeableWeight', header: 'ReceiptForm.MainTable.TotalChargeableWeight', sort: true },
      { field: 'totalGrossWeight', header: 'ReceiptForm.MainTable.TotalGrossWeight', sort: true },
      { field: 'totalVolumeWeight', header: 'ReceiptForm.MainTable.TotalVolumeWeight', sort: true },
      { field: 'totalQty', header: 'ReceiptForm.MainTable.TotalQty', sort: true },
      { field: 'rfCaseCnt', header: 'ReceiptForm.MainTable.NumofCartonsReceived', sort: true },
      { field: 'qtyReceived', header: 'ReceiptForm.MainTable.ActualQty', sort: true },
      { field: 'brand', header: 'ReceiptForm.MainTable.Brand', sort: true },
      { field: 'internalBrand', header: 'ReceiptForm.MainTable.InternalBrand', sort: true },  // V1.0 新增
      { field: 'addressCode', header: 'ReceiptForm.MainTable.WarehouseAddress', sort: true },
      { field: 'hawbFile', header: 'ReceiptForm.MainTable.ImportDeclaration', sort: true },
      { field: 'invoiceFile', header: 'ReceiptForm.MainTable.InvoiceWaybill', sort: true },
      { field: 'flightNo', header: 'ReceiptForm.MainTable.FlightNum', sort: true },
      { field: 'flightDt', header: 'ReceiptForm.MainTable.FlightDate', dataType: 'date', sort: true },
      { field: 'createDt', header: 'ReceiptForm.MainTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateDt', header: 'ReceiptForm.MainTable.EditTime', dataType: 'date', sort: true },
      { field: 'toCity', header: 'ReceiptForm.MainTable.ToCity', sort: true },
      { field: 'deliverySubType', header: 'ReceiptForm.MainTable.DeliverySubType', sort: true },
      { field: 'splitDept', header: 'ReceiptForm.MainTable.SplitDept', sort: true },
      { field: 'permitType', header: 'ReceiptForm.MainTable.PermitType', sort: true },
      { field: 'isDropShipment', header: 'ReceiptForm.MainTable.IsDropShipment', sort: true },
      { field: 'employCode', header: 'ReceiptForm.MainTable.EmployCode', sort: true },
      { field: 'isFeeCalculation', header: 'ReceiptForm.MainTable.IsFeeCalculation', sort: true },
      { field: 'bulkCargoNo', header: 'ReceiptForm.MainTable.BulkCargoNo', sort: true },
      { field: 'bulkCargoNoLocation', header: 'ReceiptForm.MainTable.BulkCargoNoLocation', sort: true },
    ];

    this.abnormalColumns = [
      { field: 'createUser', header: 'WarehousingAbnormal.Column.CreateUser', sort: true },
      { field: 'createDt', header: 'ReceiptForm.MainTable.CreationTime', sort: true },
      { field: 'updateUser', header: 'WarehousingAbnormal.Column.HandleUser', sort: true },
      { field: 'updateDt', header: 'ReceiptForm.MainTable.EditTime', sort: true },
      { field: 'whNo', header: 'ReceiptForm.MainTable.ReceiptFormNum', sort: true },
      { field: 'notifyDt', header: 'WarehousingAbnormal.Column.NotifyDt', sort: true },
      { field: 'isNotified', header: 'WarehousingAbnormal.Column.IsNotified', sort: true },
      { field: 'handleDt', header: 'WarehousingAbnormal.Column.HandleDt', sort: true },
      { field: 'isHandled', header: 'WarehousingAbnormal.Column.IsHandled', sort: true },
      { field: 'abnormalType', header: 'WarehousingAbnormal.Form.AbnormalType', sort: true },
      { field: 'pcsrReason', header: 'WarehousingAbnormal.Column.PcsrReason', sort: true },
      { field: 'pcsrRemark', header: 'WarehousingAbnormal.Column.PcsrRemark', sort: true },
    ];
    this.abnormalChildColumns = [
      { field: 'createUser', header: 'WarehousingAbnormal.Column.CreateUser', sort: true },
      { field: 'createDt', header: 'ReceiptForm.MainTable.CreationTime', sort: true },
      { field: 'updateUser', header: 'WarehousingAbnormal.Column.HandleUser', sort: true },
      { field: 'updateDt', header: 'ReceiptForm.MainTable.EditTime', sort: true },
      { field: 'sku', header: 'ShippingStatus.MODetailTable.CustomerSku', sort: true },
      { field: 'qty', header: 'ShippingStatus.MODetailTable.Qty', sort: true },
    ];
    this.adColumns = [
      { "field": "createUser", "header": "WarehousingAbnormal.AdHeaderColumn.createUser", "sort": true },
      { "field": "createDt", "header": "WarehousingAbnormal.AdHeaderColumn.createDt", "sort": true },
      { "field": "updateUser", "header": "WarehousingAbnormal.AdHeaderColumn.updateUser", "sort": true },
      { "field": "updateDt", "header": "WarehousingAbnormal.AdHeaderColumn.updateDt", "sort": true },
      { "field": "facility", "header": "WarehousingAbnormal.AdHeaderColumn.facility", "sort": true },
      { "field": "storer", "header": "WarehousingAbnormal.AdHeaderColumn.storer", "sort": true },
      { "field": "orgId", "header": "WarehousingAbnormal.AdHeaderColumn.orgId", "sort": true },
      { "field": "organizationCode", "header": "WarehousingAbnormal.AdHeaderColumn.organizationCode", "sort": true },
      { "field": "organizationId", "header": "WarehousingAbnormal.AdHeaderColumn.organizationId", "sort": true },
      { "field": "erpCode", "header": "WarehousingAbnormal.AdHeaderColumn.erpCode", "sort": true },
      { "field": "adNo", "header": "WarehousingAbnormal.AdHeaderColumn.adNo", "sort": true },
      { "field": "receiptDate", "header": "WarehousingAbnormal.AdHeaderColumn.receiptDate", "sort": true },
      { "field": "notes", "header": "WarehousingAbnormal.AdHeaderColumn.notes", "sort": true },
      { "field": "receiptDocType", "header": "WarehousingAbnormal.AdHeaderColumn.receiptDocType", "sort": true },
      { "field": "receiptDocCategory", "header": "WarehousingAbnormal.AdHeaderColumn.receiptDocCategory", "sort": true },
      { "field": "invoiceNo", "header": "WarehousingAbnormal.AdHeaderColumn.invoiceNo", "sort": true },
      { "field": "customsDeclarationNo", "header": "WarehousingAbnormal.AdHeaderColumn.customsDeclarationNo", "sort": true },
      { "field": "pcsrName", "header": "WarehousingAbnormal.AdHeaderColumn.pcsrName", "sort": true },
      { "field": "pcsrDept", "header": "WarehousingAbnormal.AdHeaderColumn.pcsrDept", "sort": true },
      { "field": "vendorId", "header": "WarehousingAbnormal.AdHeaderColumn.vendorId", "sort": true },
      { "field": "vendorNumber", "header": "WarehousingAbnormal.AdHeaderColumn.vendorNumber", "sort": true },
      { "field": "vendorName", "header": "WarehousingAbnormal.AdHeaderColumn.vendorName", "sort": true },
      { "field": "salesName", "header": "WarehousingAbnormal.AdHeaderColumn.salesName", "sort": true },
      { "field": "salesDept", "header": "WarehousingAbnormal.AdHeaderColumn.salesDept", "sort": true },
      { "field": "whRcvPractice", "header": "WarehousingAbnormal.AdHeaderColumn.whRcvPractice", "sort": true },
      { "field": "totalQty", "header": "WarehousingAbnormal.AdHeaderColumn.totalQty", "sort": true },
      { "field": "expectedDt", "header": "WarehousingAbnormal.AdHeaderColumn.expectedDt", "sort": true },
      { "field": "arriveDt", "header": "WarehousingAbnormal.AdHeaderColumn.arriveDt", "sort": true },
      { "field": "arriveUser", "header": "WarehousingAbnormal.AdHeaderColumn.arriveUser", "sort": true },
      { "field": "receivingDt", "header": "WarehousingAbnormal.AdHeaderColumn.receivingDt", "sort": true },
      { "field": "receivingUser", "header": "WarehousingAbnormal.AdHeaderColumn.receivingUser", "sort": true },
      { "field": "cancelDt", "header": "WarehousingAbnormal.AdHeaderColumn.cancelDt", "sort": true },
      { "field": "cancelUser", "header": "WarehousingAbnormal.AdHeaderColumn.cancelUser", "sort": true },
      { "field": "receivedDt", "header": "WarehousingAbnormal.AdHeaderColumn.receivedDt", "sort": true },
      { "field": "receivedUser", "header": "WarehousingAbnormal.AdHeaderColumn.receivedUser", "sort": true },
      { "field": "erpConfDt", "header": "WarehousingAbnormal.AdHeaderColumn.erpConfDt", "sort": true },
      { "field": "erpConfUser", "header": "WarehousingAbnormal.AdHeaderColumn.erpConfUser", "sort": true },
      { "field": "billOfLading", "header": "WarehousingAbnormal.AdHeaderColumn.billOfLading", "sort": true },
      { "field": "docStatus", "header": "WarehousingAbnormal.AdHeaderColumn.docStatus", "sort": true },
      { "field": "priority", "header": "WarehousingAbnormal.AdHeaderColumn.priority", "sort": true },
      { "field": "arrivalCnt", "header": "WarehousingAbnormal.AdHeaderColumn.arrivalCnt", "sort": true },
      { "field": "arrivalPal", "header": "WarehousingAbnormal.AdHeaderColumn.arrivalPal", "sort": true },
      { "field": "printStatus", "header": "WarehousingAbnormal.AdHeaderColumn.printStatus", "sort": true },
      { "field": "tenant", "header": "WarehousingAbnormal.AdHeaderColumn.tenant", "sort": true },
      { "field": "transactionId", "header": "WarehousingAbnormal.AdHeaderColumn.transactionId", "sort": true },
      { "field": "bondedNo", "header": "WarehousingAbnormal.AdHeaderColumn.bondedNo", "sort": true },
      { "field": "warehousingSyncFlag", "header": "WarehousingAbnormal.AdHeaderColumn.warehousingSyncFlag", "sort": true },
      { "field": "externalAdNo", "header": "WarehousingAbnormal.AdHeaderColumn.externalAdNo", "sort": true },
      { "field": "externalAdType", "header": "WarehousingAbnormal.AdHeaderColumn.externalAdType", "sort": true },
      { "field": "transmitChannel", "header": "WarehousingAbnormal.AdHeaderColumn.transmitChannel", "sort": true },
      { "field": "waitingReference", "header": "WarehousingAbnormal.AdHeaderColumn.waitingReference", "sort": true },
      { "field": "PCSREmployeeCode", "header": "WarehousingAbnormal.AdHeaderColumn.PCSREmployeeCode", "sort": true },
      { "field": "PCSREmail", "header": "WarehousingAbnormal.AdHeaderColumn.PCSREmail", "sort": true },
      { "field": "invoiceDate", "header": "WarehousingAbnormal.AdHeaderColumn.invoiceDate", "sort": true },
      { "field": "PoNo", "header": "WarehousingAbnormal.AdHeaderColumn.PoNo", "sort": true },
      { "field": "Plant", "header": "WarehousingAbnormal.AdHeaderColumn.Plant", "sort": true },
      { "field": "CustomerImportNo", "header": "WarehousingAbnormal.AdHeaderColumn.CustomerImportNo", "sort": true },
      { "field": "DeclType", "header": "WarehousingAbnormal.AdHeaderColumn.DeclType", "sort": true },
      { "field": "RefBillNo", "header": "WarehousingAbnormal.AdHeaderColumn.RefBillNo", "sort": true },
      { "field": "GdsType", "header": "WarehousingAbnormal.AdHeaderColumn.GdsType", "sort": true },
      { "field": "estimatedArrivalCnt", "header": "WarehousingAbnormal.AdHeaderColumn.estimatedArrivalCnt", "sort": true }
    ];
    this.adChildColumns = [
      { "field": "seqNo", "header": "WarehousingAbnormal.AdDetailColumn.seqNo", "sort": true },
      { "field": "createUser", "header": "WarehousingAbnormal.AdDetailColumn.createUser", "sort": true },
      { "field": "createDt", "header": "WarehousingAbnormal.AdDetailColumn.createDt", "sort": true },
      { "field": "updateUser", "header": "WarehousingAbnormal.AdDetailColumn.updateUser", "sort": true },
      { "field": "updateDt", "header": "WarehousingAbnormal.AdDetailColumn.updateDt", "sort": true },
      { "field": "facility", "header": "WarehousingAbnormal.AdDetailColumn.facility", "sort": true },
      { "field": "storer", "header": "WarehousingAbnormal.AdDetailColumn.storer", "sort": true },
      { "field": "orgId", "header": "WarehousingAbnormal.AdDetailColumn.orgId", "sort": true },
      { "field": "organizationCode", "header": "WarehousingAbnormal.AdDetailColumn.organizationCode", "sort": true },
      { "field": "AdSeqNo", "header": "WarehousingAbnormal.AdDetailColumn.AdSeqNo", "sort": true },
      { "field": "receiptLineNo", "header": "WarehousingAbnormal.AdDetailColumn.receiptLineNo", "sort": true },
      { "field": "externLineNo", "header": "WarehousingAbnormal.AdDetailColumn.externLineNo", "sort": true },
      { "field": "adNo", "header": "WarehousingAbnormal.AdDetailColumn.adNo", "sort": true },
      { "field": "sku", "header": "WarehousingAbnormal.AdDetailColumn.sku", "sort": true },
      { "field": "expectedQty", "header": "WarehousingAbnormal.AdDetailColumn.expectedQty", "sort": true },
      { "field": "remark", "header": "WarehousingAbnormal.AdDetailColumn.remark", "sort": true },
      { "field": "billsOfLading", "header": "WarehousingAbnormal.AdDetailColumn.billsOfLading", "sort": true },
      { "field": "specNo", "header": "WarehousingAbnormal.AdDetailColumn.specNo", "sort": true },
      { "field": "kitNo", "header": "WarehousingAbnormal.AdDetailColumn.kitNo", "sort": true },
      { "field": "veItemNo", "header": "WarehousingAbnormal.AdDetailColumn.veItemNo", "sort": true },
      { "field": "customerNumber", "header": "WarehousingAbnormal.AdDetailColumn.customerNumber", "sort": true },
      { "field": "customerName", "header": "WarehousingAbnormal.AdDetailColumn.customerName", "sort": true },
      { "field": "subinvName", "header": "WarehousingAbnormal.AdDetailColumn.subinvName", "sort": true },
      { "field": "xdockKey", "header": "WarehousingAbnormal.AdDetailColumn.xdockKey", "sort": true },
      { "field": "subinvDescr", "header": "WarehousingAbnormal.AdDetailColumn.subinvDescr", "sort": true },
      { "field": "hsFlag", "header": "WarehousingAbnormal.AdDetailColumn.hsFlag", "sort": true },
      { "field": "salesDept", "header": "WarehousingAbnormal.AdDetailColumn.salesDept", "sort": true },
      { "field": "salesName", "header": "WarehousingAbnormal.AdDetailColumn.salesName", "sort": true },
      { "field": "poNo", "header": "WarehousingAbnormal.AdDetailColumn.poNo", "sort": true },
      { "field": "poSeq", "header": "WarehousingAbnormal.AdDetailColumn.poSeq", "sort": true },
      { "field": "reservedOrgId", "header": "WarehousingAbnormal.AdDetailColumn.reservedOrgId", "sort": true },
      { "field": "mfgPartId", "header": "WarehousingAbnormal.AdDetailColumn.mfgPartId", "sort": true },
      { "field": "supplierRegion", "header": "WarehousingAbnormal.AdDetailColumn.supplierRegion", "sort": true },
      { "field": "license", "header": "WarehousingAbnormal.AdDetailColumn.license", "sort": true },
      { "field": "invoiceNo", "header": "WarehousingAbnormal.AdDetailColumn.invoiceNo", "sort": true },
      { "field": "deliveryNo", "header": "WarehousingAbnormal.AdDetailColumn.deliveryNo", "sort": true },
      { "field": "brand", "header": "WarehousingAbnormal.AdDetailColumn.brand", "sort": true },
      { "field": "internalBrand", "header": "WarehousingAbnormal.AdDetailColumn.internalBrand", "sort": true },  // V1.0 新增
      { "field": "specLocType", "header": "WarehousingAbnormal.AdDetailColumn.specLocType", "sort": true },
      { "field": "vendorLot", "header": "WarehousingAbnormal.AdDetailColumn.vendorLot", "sort": true },
      { "field": "vendorDc", "header": "WarehousingAbnormal.AdDetailColumn.vendorDc", "sort": true },
      { "field": "reservedConsigneeKey", "header": "WarehousingAbnormal.AdDetailColumn.reservedConsigneeKey", "sort": true },
      { "field": "CaseID", "header": "WarehousingAbnormal.AdDetailColumn.CaseID", "sort": true },
      { "field": "BoxID", "header": "WarehousingAbnormal.AdDetailColumn.BoxID", "sort": true },
      { "field": "Hue", "header": "WarehousingAbnormal.AdDetailColumn.Hue", "sort": true },
      { "field": "VendorCategory", "header": "WarehousingAbnormal.AdDetailColumn.VendorCategory", "sort": true },
      { "field": "invoiceDate", "header": "WarehousingAbnormal.AdDetailColumn.invoiceDate", "sort": true },
      { "field": "coo", "header": "WarehousingAbnormal.AdDetailColumn.coo", "sort": true },
      { "field": "DnNo", "header": "WarehousingAbnormal.AdDetailColumn.DnNo", "sort": true },
      { "field": "DnLineNo", "header": "WarehousingAbnormal.AdDetailColumn.DnLineNo", "sort": true },
      { "field": "Location", "header": "WarehousingAbnormal.AdDetailColumn.Location", "sort": true },
      { "field": "StrUnit", "header": "WarehousingAbnormal.AdDetailColumn.StrUnit", "sort": true },
      { "field": "CccCode", "header": "WarehousingAbnormal.AdDetailColumn.CccCode", "sort": true },
      { "field": "PermitWeek", "header": "WarehousingAbnormal.AdDetailColumn.PermitWeek", "sort": true },
      { "field": "StsFlag", "header": "WarehousingAbnormal.AdDetailColumn.StsFlag", "sort": true },
      { "field": "SkuDesc", "header": "WarehousingAbnormal.AdDetailColumn.SkuDesc", "sort": true },
      { "field": "asnNo", "header": "WarehousingAbnormal.AdDetailColumn.asnNo", "sort": true },
      { "field": "AsnItemNo", "header": "WarehousingAbnormal.AdDetailColumn.AsnItemNo", "sort": true },
      { "field": "ItemNo", "header": "WarehousingAbnormal.AdDetailColumn.ItemNo", "sort": true },
      { "field": "PoType", "header": "WarehousingAbnormal.AdDetailColumn.PoType", "sort": true }
    ];

    this.isShowWarehousingAbnormalHistoryModal = false;
    this.isShowWarehousingAbnormalTrackingForShippingModal = false;
    this.isShowWarehousingAbnormalHandlingForPcsrModal = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.initMenus();
    this.initOptions();
    this.initFacilityOption();
    this.confirmQueryParamsAndPerformAutomaticQuery();
    /* 添加這段代碼來監聽螢幕寬度變化 */
    this.menuDataService.isRwd.subscribe(result => {
      this.isRwd = result;
    });

  }

  private initFacilityOption() {
    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options;
      }
    })
  }

  private confirmQueryParamsAndPerformAutomaticQuery(): void {
    this.route.queryParams.subscribe((params: Params) => {
      const paramsKeys = Object.keys(params);
      const needParams = ['whNoLinkParams', 'hawbNoLinkParams', 'facility'];
      if (!needParams.some((key) => paramsKeys.includes(key))) {
        this.searchForm.controls['facility'].setValue([this.laasSetting.facility]);
        return;
      }
      if (params['whNoLinkParams']) {
        const whNos = params['whNoLinkParams'].split(';').filter((whNo: any) => !isNullOrEmpty(whNo));
        if (whNos.length > 0) {
          this.searchForm.controls["whNo"].setValue(whNos);
        }
      }
      if (params['hawbNoLinkParams']) {
        const hawbNos = params['hawbNoLinkParams'].split(';').filter((hawNo: any) => !isNullOrEmpty(hawNo));
        if (hawbNos.length > 0) {
          this.searchForm.controls["hawbNo"].setValue(hawbNos);
        }
      }
      if (params['facility']) {
        const facility = params['facility'].split(';').filter((facility: any) => !isNullOrEmpty(facility));
        if (facility.length > 0) {
          this.searchForm.controls["facility"].setValue(facility);
        }
      }
      console.log(`confirmQueryParamsAndPerformAutomaticQuery start searching...`);
      this.searchBtnClick();
    });
  }

  initMenus(): void {
    /* 初始化入倉單Header功能按鈕 */
    this.itemMenus = [
      {
        label: this.translateService.instant('Common.Button.Import'),
        command: () => {
          /* 將目前選取的提單號碼寫入importParams */
          console.log(`this.hawbTable.selectedRow=${JSON.stringify(this.hawbTable.selectedRow)}`);
          const rowData = this.hawbTable.selectedRow;
          this.openWarehousingAbnormalHandlingForPcsrDialog(event, rowData);
        },
        visible: this.hasPermissionOfWarehousingAbnormalHandlingForPcsrDialog()
      }
    ];
  }

  initOptions(): void {
    /* 實作取得品牌、計費公司、異常類型、是否通知、是否處理的下拉選單資料 */
    /* 異常類型 */
    this.abnormalTypeOptions = [
      { label: this.translateService.instant(`ReceiptForm.Button.${WarehousingAbnormalType.RemainingSku}`), value: WarehousingAbnormalType.RemainingSku },
      { label: this.translateService.instant(`ReceiptForm.Button.${WarehousingAbnormalType.RfCheckedNoAd}`), value: WarehousingAbnormalType.RfCheckedNoAd },
    ];

    /* 異常已通知；異常已處理的選項 */
    this.yesNoOptions = [
      { label: this.translateService.instant('FacilityOptionMaintenance.Option.IsDefaultAwbAddress.Yes'), value: true },
      { label: this.translateService.instant('FacilityOptionMaintenance.Option.IsDefaultAwbAddress.No'), value: false },
    ];

    this.ynOptions = [
      { label: this.translateService.instant('FacilityOptionMaintenance.Option.IsDefaultAwbAddress.Yes'), value: 'Y' },
      { label: this.translateService.instant('FacilityOptionMaintenance.Option.IsDefaultAwbAddress.No'), value: 'N' },
    ];

    /* 品牌 */
    this.dropdownOptionsService.getBrandOptions(1).subscribe({
      next: (options: { brandName: string }[]) => {
        this.brandOptions = options.map(({ brandName: label, brandName: value }) => ({ label, value }));
        this.internalBrandOptions = options.map(({ brandName: label, brandName: value }) => ({ label, value }));
      }
    });

    /* 公司 orgId */
    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "").subscribe({
      next: (options: { billOUCode: string, billOUName: string, billReferenceCode: string, legalEntityOUCode: string, legalEntityOUName: string, legalEntityReferenceCode: string }[]) => {
        this.billCorpOptions = options.filter(({ billOUCode }) => billOUCode !== null)
          .map(({ billOUCode, billOUName, billReferenceCode }) => ({
            label: `${billOUCode}-${billOUName}(${billReferenceCode})`,
            value: billOUCode,
          }));
        this.letterHeadOptions = options.map(({ legalEntityOUCode, legalEntityOUName, legalEntityReferenceCode }) => ({
          label: `${legalEntityOUCode}-${legalEntityOUName} ( ${legalEntityReferenceCode} )`,
          value: legalEntityOUCode,
        }));
      }
    });

    /* 下面選項是warehousing-search中取得的，這裡在入倉單Header中也有使用到，因此也一併取得 */
    this.isActivatedOptions = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.urgentFlagOptions = [
      { label: '非急單', value: '5' },
      { label: '急單', value: '1' }
    ];

    this.isGenerateFeeOptions = [
      { label: 'ALL', value: null },
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.isFeeCalculationOptions = [
      { label: 'ALL', value: null },
      { label: 'Y-已計算費用', value: 'Y' },
      { label: 'N-未計算費用', value: 'N' },
      { label: 'X-無費用', value: 'X' }
    ];

    /* 單據類型 */
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ReasonForImportingAdvisingFailure')
      .subscribe({
        next: (options: any[]) => {
          this.deliveryOptions = options.map(x => ({ label: x.codeDesc, value: x.codeDesc }));
        }
      });

    this.dropdownOptionsService.getWhDocStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.whDocStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.shipTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getCountryOptions()
      .subscribe({
        next: (options: any[]) => {
          this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
        }
      });

    this.facilityService.getImportDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.dropdownOptionsService.getPickupLocationOptions(this.laasSetting.facility)
      .subscribe({
        next: (options: any[]) => {
          this.pickupLocationOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shipMethodOptions = result.map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.dropdownOptionsService.getPriorityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.priorityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getAllCityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.allCityOptions = options.map(x => ({ label: x.name, value: x.seqNo.toString(), country: x.country }));
        }
      });

    /* 區域 */
    this.dropdownOptionsService.getAllAreaOptionForHK()
      .subscribe({
        next: (options: any[]) => {
          this.allAreaOptions = options.map(x => ({ label: x.rfqAreaName, value: x.rfqAreaCode, citySeqNo: x.citySeqNo }));
        }
      });

    this.facilityService.getImportTypeOptions().subscribe({
      next: result => {
        this.importTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.dropdownOptionsService.getWhDetailStatusOptions().subscribe({
      next: (options: any[]) => {
        this.whDetailStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliverySubType').subscribe({
      next: result => {
        this.deliverySubTypeOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });

      }
    });
  }

  accordionTabOpen(): void {
    this.isSearchFormOpen = true;
  }

  searchBtnClick(): void {
    /* 清除table分頁條件 */
    this.pageInfo.pageIndex = 0;
    this.hawbTable.setCurrentPage(0);
    this.searchWarehousingAbnormal();
  }

  searchWarehousingAbnormal(): void {
    /* 實作call api搜尋資料 */
    if (this.searchForm.invalid) return;

    const params = {
      facility: this.searchForm.value.facility,
      ...this.searchForm.value,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder,
    }
    params.userDataScopes = getDataScopeByPermission(this.userProfile, PermissionConstants.ViewWarehousingAbnormal);

    console.log('查詢條件:', params);

    this.isLoading = true;
    this.loader.show();
    this.warehousingAbnormalService.searchWarehousingAbnormal(params).subscribe({
      next: (result: { content: { hawbNo: string }[], totalElements: number }) => {
        /* 成功取得資料 */
        this.isSearchFormOpen = false;
        const hawbChildResults = result.content.groupBy(x => x.hawbNo);
        this.hawbResults = Array.from(new Set(result.content.map(({ hawbNo }) => (hawbNo)))).map((hawbNo) => ({ hawbNo, warehousingDetail: hawbChildResults[hawbNo] }));
        this.pageInfo.totalRecords = result.totalElements;
        this.hawbTable.setPageInfo(this.pageInfo.totalRecords);
        this.isHawbTableOpen = true;
        this.isAbnormalTableOpen = false;
        this.isAdTableOpen = false;
      },
      error: (error: any) => {
        /* 錯誤處理 */
        this.pageInfo.totalRecords = 0;
        this.hawbTable.setPageInfo(this.pageInfo.totalRecords);
        this.toastErrorMessage(error.error);
        this.loader.hide();
      },
      complete: () => {
        this.isLoading = false;
        this.loader.hide();
      }
    });
  }

  dateOnChange({ startDate, endDate }: { startDate: Date, endDate: Date }, type: string): void {
    /* 當日期改變時，將日期資料寫入searchForm */
    this.searchForm.patchValue({
      [`start${capitalizeFirstLetter(type)}`]: startDate,
      [`end${capitalizeFirstLetter(type)}`]: endDate,
    });
  }

  resetBtn(): void {
    /* 重設查詢表單 */
    this.whDt.ngOnInit();
    this.notifyDt.ngOnInit();
    this.handleDt.ngOnInit();
    this.searchForm.reset();
  }

  tablePageChange(event: any, type: string): void {
    if (type == 'hawb') {
      this.pageInfo.pageSize = event.rows;
      this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
      this.searchWarehousingAbnormal();
    }

    if (type == 'abnormal') {
      this.abnormalPageInfo.pageSize = event.rows;
      this.abnormalPageInfo.pageIndex = event.first / this.abnormalPageInfo.pageSize;
      this.searchAbnormal();
    }

    if (type == 'ad') {
      this.adPageInfo.pageSize = event.rows;
      this.adPageInfo.pageIndex = event.first / this.adPageInfo.pageSize;
      this.searchAd();
    }
  }

  tableSort(event: any, type: string): void {
    if (type == 'hawb') {
      this.sortOrder = { property: event.field, direction: event.order };
      this.hawbTable.setCurrentPage(0);
      this.searchWarehousingAbnormal();
    }

    if (type == 'abnormal') {
      this.abnormalSortOrder = { property: event.field, direction: event.order };
      this.abnormalTable.setCurrentPage(0);
      this.searchAbnormal();
    }

    if (type == 'ad') {
      this.adSortOrder = { property: event.field, direction: event.order };
      this.adTable.setCurrentPage(0);
      this.searchAd();
    }
  }

  searchAbnormal(): void {
    this.isAbnormalLoading = true;
    const params = {
      whNo: this.selectedRow.warehousingDetail.map(({ whNo }) => whNo),
      pageIndex: this.abnormalPageInfo.pageIndex,
      pageSize: this.abnormalPageInfo.pageSize,
      sortOrder: this.abnormalSortOrder,
    }
    this.loader.show();
    this.warehousingAbnormalService.searchWarehousingAbnormalHeader(params).subscribe({
      next: (abnormalResult: { content: any, totalElements: number }) => {
        /* 成功取得資料 */
        this.abnormalResults = abnormalResult.content;
        this.abnormalPageInfo.totalRecords = abnormalResult.totalElements;
        this.abnormalTable.setPageInfo(this.abnormalPageInfo.totalRecords);
      },
      error: (error: any) => {
        /* 錯誤處理 */
        this.abnormalPageInfo.totalRecords = 0;
        this.abnormalTable.setPageInfo(this.abnormalPageInfo.totalRecords);
        this.toastErrorMessage(error.error);
        this.loader.hide();
      },
      complete: () => {
        this.isAbnormalLoading = false;
        this.isAbnormalTableOpen = true;
        this.loader.hide();
      }
    });
  }

  searchAd(): void {
    this.isAdLoading = true;
    const params = {
      hawbNo: this.selectedRow.hawbNo,
      pageIndex: this.adPageInfo.pageIndex,
      pageSize: this.adPageInfo.pageSize,
      sortOrder: this.adSortOrder,
    }
    this.loader.show();
    this.warehousingAbnormalService.searchWarehousingAdHeader(params).subscribe({
      next: (adResult: { content: any, totalElements: number }) => {
        /* 成功取得資料 */
        this.adResults = adResult.content;
        this.adPageInfo.totalRecords = adResult.totalElements;
        this.adTable.setPageInfo(this.adPageInfo.totalRecords);
      },
      error: (error: any) => {
        /* 錯誤處理 */
        this.adPageInfo.totalRecords = 0;
        this.adTable.setPageInfo(this.adPageInfo.totalRecords);
        this.toastErrorMessage(error.error);
        this.loader.hide();
      },
      complete: () => {
        this.isAdLoading = false;
        this.isAdTableOpen = true;
        this.loader.hide();
      }
    });
  }

  onRowClick(row: { hawbNo: string, warehousingDetail: { whNo: string }[] }): void {
    /* 點擊提單號row時，連動異常 Header與AD Header */
    this.abnormalPageInfo.pageIndex = 0;
    this.abnormalTable.setCurrentPage(0);
    this.adPageInfo.pageIndex = 0;
    this.adTable.setCurrentPage(0);
    this.selectedRow = row;
    this.searchAbnormal();
    this.searchAd();
  }

  openWarehousingAbnormalHistoryDialog(rowData: any): void {
    this.isShowWarehousingAbnormalHistoryModal = false;
    console.log(`isShowWarehousingAbnormalHistoryModal=${this.isShowWarehousingAbnormalHistoryModal}, rowData=${JSON.stringify(rowData)}`);
    this.warehousingAbnormalHistoryParams = {
      whNo: rowData.whNo,
      abnormalTypeOptions: this.abnormalTypeOptions
    }
    this.isShowWarehousingAbnormalHistoryModal = true;
  }

  closeWarehousingAbnormalHistoryDialog(event: any): void {
    console.log(`closeWarehousingAbnormalHistoryDialog`);
    this.isShowWarehousingAbnormalHistoryModal = false;
  }

  openWarehousingAbnormalTrackingForShippingDialog(rowData: any): void {

    this.isShowWarehousingAbnormalTrackingForShippingModal = false;
    console.log(`isShowWarehousingAbnormalTrackingForShippingModal=${this.isShowWarehousingAbnormalTrackingForShippingModal}, rowData=${JSON.stringify(rowData)}`);
    this.warehousingAbnormalTrackingForShippingParams = {
      importFailReason: rowData.importFailReason,
      remarks: rowData.remarks,
      whNo: rowData.whNo,
      warehousingAbnormalSeqNo: rowData.warehousingAbnormalSeqNo
    }

    this.isShowWarehousingAbnormalTrackingForShippingModal = true;
  }

  closeWarehousingAbnormalTrackingForShippingDialog(event: any): void {
    console.log(`closeWarehousingAbnormalTrackingForShippingDialog`);
    this.isShowWarehousingAbnormalTrackingForShippingModal = false;
    this.searchWarehousingAbnormal();
  }

  openWarehousingAbnormalHandlingForPcsrDialog(event: any, rowData: any): void {
    const whNoAbnormalSeqNoMappings = rowData.warehousingDetail.map(({ whNo, warehousingAbnormalSeqNo }: { whNo: string, warehousingAbnormalSeqNo: number }) => ({ whNo, warehousingAbnormalSeqNo }));
    this.isShowWarehousingAbnormalHandlingForPcsrModal = false;
    console.log(`isShowWarehousingAbnormalHandlingForPcsrModal=${this.isShowWarehousingAbnormalHandlingForPcsrModal}, rowData=${JSON.stringify(rowData)}`);
    this.warehousingAbnormalHandlingForPcsrParams = {
      deliveryOptions: this.deliveryOptions,
      whNoAbnormalSeqNoMappings: whNoAbnormalSeqNoMappings,
      hawbNo: rowData.hawbNo,
    }

    this.isShowWarehousingAbnormalHandlingForPcsrModal = true;
  }

  closeWarehousingAbnormalHandlingForPcsrDialog(event: any): void {
    console.log(`closeWarehousingAbnormalTrackingForShippingDialog`);
    this.isShowWarehousingAbnormalHandlingForPcsrModal = false;
    this.searchWarehousingAbnormal();
  }

  hasPermissionOfWarehousingAbnormalHandlingForPcsrDialog(): boolean {
    return this.permissionCodes.includes(PermissionConstants.ViewWarehousingAbnormalHandlingForPcsrDialog);
  }

  hasPermissionOfWarehousingAbnormalTrackingForShippingDialog(): boolean {
    return this.permissionCodes.includes(PermissionConstants.ViewWarehousingAbnormalTrackingForShippingDialog);
  }
}
